//@flow
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import ConfirmPersonalInfo from './ConfirmPersonalInfo';
import { arePersonalInfoModified } from './lib';
import { confirmPersonalInfo, hasEditedIdentificationInfo } from '../../../modules/Customer';
import { setDeliveryContact } from '../../../modules/SignUp/DeliveryContact';
import config from '../../../config';
import { formActivatePersonalInfoSelector } from '../../../modules/selectors';
import type { StateProps, DispatchProps, MergeProps } from './ConfirmPersonalInfo';
import validate from './validation';
import { isLoadingSelector } from '../../../modules/LoadingStatus';

const mapStateToProps = (state): StateProps => {
  const formSelector = formValueSelector('personalInfo');
  return {
    initialValues: formActivatePersonalInfoSelector(state),
    isLoading: isLoadingSelector(state, 'confirmPersonalInfo'),
    selectedGender: formSelector(state, 'gender'),
  };
};

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  hasEditedIdentificationInfo: () => dispatch(hasEditedIdentificationInfo()),
  confirmPersonalInfo: values => dispatch(confirmPersonalInfo(values, true)),
  setDeliveryContact: values => {
    config.askPersonalInformationDuringOrderSim &&
      dispatch(
        setDeliveryContact({ name: `${values.givenName} ${values.familyName}`, phoneNumber: values.contactPhoneNumber })
      );
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps): MergeProps => ({
  onSubmit: values => {
    if (arePersonalInfoModified(values, stateProps.initialValues)) {
      dispatchProps.hasEditedIdentificationInfo();
    }
    dispatchProps.confirmPersonalInfo({
      ...values,
    });
    dispatchProps.setDeliveryContact(values);
  },
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({ form: 'personalInfo', validate })
);
export default enhance(ConfirmPersonalInfo);
